var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackB(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Menu"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.23,18a.51.51,0,0,1-.36-.15l-5-5a.5.5,0,0,1,0-.7.5.5,0,0,1,.71,0l5,5a.5.5,0,0,1-.35.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.23,13a.51.51,0,0,1-.36-.15.5.5,0,0,1,0-.7l5-5a.5.5,0,0,1,.71,0,.48.48,0,0,1,0,.7l-5,5A.49.49,0,0,1,9.23,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.5,1A11.5,11.5,0,1,1,1,12.5,11.51,11.51,0,0,1,12.5,1m0-1A12.5,12.5,0,1,0,25,12.5,12.5,12.5,0,0,0,12.5,0Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackB);
export default __webpack_public_path__ + "static/media/back-b.fdd11e6d4497f381bac6405ae517d201.svg";
export { ForwardRef as ReactComponent };